import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useUrlParams = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  return useMemo(() => {
    const accountKey = queryParams.get("account");
    const lng = queryParams.get("lng");
    return {
      accountKey: accountKey,
      lng: lng,
      work: location.pathname.split("/")[1],
    };
  }, [location]);
};
